export default "__VITE_ASSET__M2ya97AR__"